
export const common = {
  // Navigation
  'nav.features': 'Fonctionnalités',
  'nav.howItWorks': 'Comment ça marche',
  'nav.pricing': 'Tarifs',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'À propos',
  'nav.getStarted': 'Commencer',

  // About Us Section
  'aboutUs.badge': 'À propos',
  'aboutUs.title': 'À propos de nous',
  'aboutUs.line1': 'Les idées sont bon marché.',
  'aboutUs.line2': 'Le capital non. Le temps encore moins.',
  'aboutUs.paragraph1':
    'IdeaOracle.ai a été fondé parce que la plupart des idées commerciales n\'échouent pas par manque de courage – mais par manque d\'honnêteté. Trop de validation. Trop peu de réalité.',
  'aboutUs.belief1a': 'Nous ne croyons pas au battage médiatique.',
  'aboutUs.belief1b': 'Nous croyons à la logique du marché.',
  'aboutUs.belief2a': 'Nous ne croyons pas à la motivation.',
  'aboutUs.belief2b': 'Nous croyons à la demande, la concurrence et la différenciation.',
  'aboutUs.mission1': 'Notre mission n\'est pas de rendre les idées attrayantes.',
  'aboutUs.mission2': 'Notre mission est de révéler leur viabilité.',
  'aboutUs.analysis':
    'IdeaOracle.ai analyse les niches commerciales sur la mécanique structurelle du marché, la demande réaliste, l\'intensité concurrentielle et la faisabilité. Pas émotionnel. Pas optimiste. Mais sobre.',
  'aboutUs.failure1': 'La plupart des idées échouent.',
  'aboutUs.failure2': 'Pas parce que les fondateurs sont incapables –',
  'aboutUs.failure3': 'mais parce que personne n\'a été assez clair avant.',
  'aboutUs.clarity': 'Nous existons pour fournir cette clarté.',
  'aboutUs.value1': 'Inconfortable.',
  'aboutUs.value2': 'Direct.',
  'aboutUs.value3': 'Conséquent.',
  'aboutUs.confirm': 'Si une idée a de la substance, nous la confirmons.',
  'aboutUs.deny': 'Sinon, nous le disons aussi.',
  'aboutUs.noApplause': 'Sans applaudissements.',
  'aboutUs.noSugarcoating': 'Sans embellissement.',
  'aboutUs.noTheater': 'Sans théâtre.',

  // Hero Section
  'hero.badge': 'IA de décision pour niches commerciales',
  'hero.title1': 'Les idées sont bon marché.',
  'hero.title2': 'Les mauvaises décisions ne le sont pas.',
  'hero.subtitle': 'Une IA qui évalue votre niche commerciale',
  'hero.subtitleLine2': 'avant que vous n\'investissiez.',
  'hero.cta': 'Vérifier l\'idée',
  'hero.ctaSecondary': 'Comment ça marche',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Crédits par demande',
  'hero.stat2Value': 'Dès 7',
  'hero.stat2Label': 'Niveaux d\'évaluation',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Honnête & Privé',

  // Features Section
  'features.title1': 'Fonctionnalités puissantes pour',
  'features.title2': 'entreprises',
  'features.title3': 'modernes',
  'features.honestVerdict.title': 'Verdict honnête, pas un score de hype',
  'features.honestVerdict.description': 'Verdicts bon/moyen/faible tranchés, appuyés sur de vraies données de marché et une recherche concurrentielle. Aucune note 9/10 destinée à flatter chaque idée.',
  'features.fullJourney.title': 'Du test d’idée au Builder Report',
  'features.fullJourney.description': 'Valide dans le chat, approfondis l’analyse de marché, exporte un Builder Report de 25 à 75 pages avec personas, plan financier, go-to-market et pitch deck.',
  'features.multilingual.title': '21 langues, données de marché locales',
  'features.multilingual.description': 'De la PME suisse au fondateur solo à São Paulo — l’IA répond dans ta langue, avec des sources de ton marché.',

  // How It Works
  'howItWorks.title': 'Comment ça marche',
  'howItWorks.subtitle': 'Quatre étapes vers la clarté sur votre niche commerciale.',
  'howItWorks.step1Title': 'Choisir un plan',
  'howItWorks.step1Desc': 'Starter, Pro ou Builder – selon la profondeur de votre examen.',
  'howItWorks.step2Title': 'Interroger l\'IA',
  'howItWorks.step2Desc': 'Posez vos questions sur la niche. Chaque demande coûte 30 crédits.',
  'howItWorks.step3Title': 'Obtenir un verdict honnête',
  'howItWorks.step3Desc': 'L\'IA évalue : Bon, Moyen ou Mauvais. Sans détour.',
  'howItWorks.step4Title': 'Prendre une décision',
  'howItWorks.step4Desc': 'Vous savez maintenant si cela vaut la peine de continuer.',

  // Pricing
  'pricing.title': 'Tarifs',
  'pricing.subtitle': 'Choisissez le plan qui correspond à la profondeur de votre examen.',
  'pricing.yearlyDiscount': 'Abonnement annuel :',
  'pricing.yearlyDiscountValue': '-20% de réduction',
  'pricing.perMonth': 'par mois',
  'pricing.selectPlan': 'Sélectionner le plan',
  'pricing.mostPopular': 'Le plus populaire',
  'pricing.footer':
    'Tous les prix en CHF. Les crédits ne sont déduits que pour les réponses IA réussies.',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'Pour les premiers tests de réalité.',
  'pricing.starter.credits': '2 500 crédits',
  'pricing.starter.feature1': 'Générer une idée de niche',
  'pricing.starter.feature2': 'Affiner la niche',
  'pricing.starter.feature3': 'Vérification de la réalité du marché',
  'pricing.starter.feature4': 'Évaluation de la concurrence',
  'pricing.starter.feature5': 'Évaluation du timing',
  'pricing.starter.feature6': 'Verdict honnête',
  'pricing.starter.feature7': 'Sessions privées',
  'pricing.starter.feature8': 'Historique et export',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'Pour un examen plus approfondi.',
  'pricing.pro.credits': '5 000 crédits',
  'pricing.pro.feature1': 'Toutes les fonctionnalités Starter',
  'pricing.pro.feature2': 'Plus de crédits pour un examen intensif',
  'pricing.pro.feature3': 'Suggestions d\'amélioration',
  'pricing.pro.feature4': 'Niches alternatives',
  'pricing.pro.feature5': 'Analyse de marché détaillée',
  'pricing.pro.feature6': 'Support prioritaire',
  'pricing.pro.feature7': 'Filtres avancés',
  'pricing.pro.feature8': 'Favoris de session',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'Idée → Briefing développeur.',
  'pricing.builder.credits': 'Crédits illimités',
  'pricing.builder.feature1': 'Toutes les fonctionnalités Pro',
  'pricing.builder.feature2': 'Demandes IA illimitées',
  'pricing.builder.feature3': 'Mode Builder : Briefing développeur',
  'pricing.builder.feature4': 'Aperçu structuré du projet',
  'pricing.builder.feature5': 'Flux utilisateur et fonctions principales',
  'pricing.builder.feature6': 'Notes techniques',
  'pricing.builder.feature7': 'Définir les non-objectifs',
  'pricing.builder.feature8': "Limite d'utilisation équitable",
  'pricing.builder.limitNote': "Limite d'utilisation équitable",
  'pricing.monthlyReset': 'Réinitialisation mensuelle',

  // Modal
  'pricing.modal.selected': 'sélectionné',
  'pricing.modal.comingSoon':
    "L'inscription et le traitement des paiements seront bientôt disponibles.",
  'pricing.modal.patience':
    'Nous travaillons pour vous offrir une expérience sécurisée et fluide. Veuillez patienter.',
  'pricing.modal.understood': 'Compris',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Répondu honnêtement et de manière critique.',
  'faq.q1': 'Que fait concrètement IdeaOracle.ai ?',
  'faq.a1': 'IdeaOracle.ai évalue les idées commerciales et les niches sur la logique du marché, la demande réelle, la concurrence, la différenciation et la faisabilité.\nSi la substance existe, nous montrons comment elle peut être affinée stratégiquement.\nSinon, nous le disons.',
  'faq.q2': 'Générez-vous aussi des idées ?',
  'faq.a2': 'Oui.\nMais pas aveuglément.\nNous développons des approches basées sur la logique du marché – pas sur la motivation ou le battage médiatique.',
  'faq.q3': 'Optimisez-vous les modèles commerciaux ?',
  'faq.a3': 'Oui – si le potentiel existe.\nNous ne polissons pas les illusions.\nNous rendons les concepts viables plus résistants.',
  'faq.q4': 'Qu\'est-ce qui vous distingue des autres outils IA ?',
  'faq.a4': 'Les autres outils fournissent de l\'inspiration.\nNous fournissons une évaluation.\nL\'accent est mis sur le réalisme, pas sur l\'enthousiasme.',
  'faq.q5': 'Est-ce une garantie de succès ?',
  'faq.a5': 'Non.\nNous réduisons les mauvaises décisions – nous n\'éliminons pas le risque.',
  'faq.q6': 'À qui s\'adresse IdeaOracle.ai ?',
  'faq.a6': 'Fondateurs avant le lancement\nEntrepreneurs avant l\'expansion\nSide-builders avant l\'investissement en temps\nInvestisseurs avant l\'examen\n\nEn bref : Pour les personnes qui veulent la clarté avant le capital.',
  'faq.q7': 'Et si je cherche juste une validation ?',
  'faq.a7': 'Alors IdeaOracle.ai n\'est pas le bon outil.',
  'faq.q8': 'À quel point l\'analyse est-elle honnête ?',
  'faq.a8': 'Aussi honnête que les données et la mécanique du marché le permettent.\nPas d\'euphorie. Pas de ménagement.',
  'faq.q9': 'Remplacez-vous les études de marché ?',
  'faq.a9': 'Non.\nNous sommes un pré-examen stratégique – pas une étude de marché complète.',
  'faq.q10': 'Pourquoi si intransigeant ?',
  'faq.a10': 'Parce que l\'échec coûte cher.\nL\'honnêteté non.',

  // Footer
  'footer.description':
    'Cette plateforme ne vous aide pas à vous sentir bien – mais à décider correctement.',
  'footer.product': 'Produit',
  'footer.aiAssistant': 'Assistant IA',
  'footer.howItWorks': 'Comment ça marche',
  'footer.pricing': 'Tarifs',
  'footer.faq': 'FAQ',
  'footer.legal': 'Légal',
  'footer.privacy': 'Confidentialité',
  'footer.terms': 'Conditions',
  'footer.imprint': 'Mentions légales',
  'footer.support': 'Support',
  'footer.contact': 'Contact',
  'footer.documentation': 'Documentation',
  'footer.copyright': '© 2025 IdeaOracle.ai. Tous droits réservés.',

  // AI Assistant
  'aiAssistant.title': 'Assistant IA de niche',
  'aiAssistant.subtitle': 'Questions sur les niches',
  'aiAssistant.welcomeMessage':
    "Salut ! Décrivez votre idée ou posez-moi des questions sur une niche. Je vous donnerai une évaluation claire et honnête.",
  'aiAssistant.demoResponse':
    "Ceci est une démo. Pour obtenir de vraies évaluations IA, veuillez vous inscrire et choisir un plan.",
  'aiAssistant.placeholder': 'Décrivez votre idée...',

  // Header & Sidebar
  'dashboard.header.title': 'Tableau de bord',
  'dashboard.sidebar.overview': 'Aperçu',
  'dashboard.sidebar.newAnalysis': 'Assistant IA',
  'dashboard.sidebar.history': 'Historique',
  'dashboard.sidebar.credits': 'Crédits',
  'dashboard.sidebar.settings': 'Paramètres',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Bon retour, {{name}}',
  'dashboard.overview.subtitle': 'Voici un aperçu rapide de votre activité',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Crédits restants',
  'dashboard.stats.totalAnalyses': 'Analyses totales',
  'dashboard.stats.goodRatings': 'Évaluations positives',
  'dashboard.stats.nextReset': 'Prochain reset dans',
  'dashboard.stats.days': 'jours',

  // Quick Actions
  'dashboard.quickActions.title': 'Actions rapides',
  'dashboard.quickActions.checkNewIdea': 'Vérifier une idée',
  'dashboard.quickActions.checkNewIdeaDesc': 'Analyser une idée commerciale existante',
  'dashboard.quickActions.generateIdea': 'Générer une idée',
  'dashboard.quickActions.generateIdeaDesc': 'Trouver une nouvelle niche rentable',
  'dashboard.quickActions.builderBriefing': 'Briefing Builder',
  'dashboard.quickActions.builderBriefingDesc':
    'Transformer une idée en briefing prêt pour les développeurs',
  'dashboard.quickActions.premiumOnly': 'Builder uniquement',

  // Chat Header
  'chat.title': 'Assistant IA de niche',
  'chat.subtitle': "Posez des questions sur les niches. J'évalue de manière critique et honnête.",
  'chat.creditsLabel': 'Crédits',

  // Chat Welcome
  'chat.welcomeTitle': "Bienvenue dans l'Assistant IA de niche",
  'chat.welcomeDesc':
    'Décrivez votre idée ou posez des questions sur une niche. Je l\'évaluerai honnêtement : Bon, Moyen ou Mauvais.',
  'chat.aiWelcome':
    "Salut ! Décrivez votre idée ou posez-moi des questions sur une niche. Je vous donnerai une évaluation claire et honnête.",

  // Chat Suggestions
  'chat.suggestion1': 'Trouvez-moi une niche rentable.',
  'chat.suggestion2': "J'ai une idée – évaluez-la honnêtement.",
  'chat.suggestion3': 'Quelles niches ont du potentiel en ce moment ?',
  'chat.suggestion4': 'Affinez cette niche et rendez-la plus spécifique.',

  // Chat Actions
  'chat.newConversation': 'Nouvelle conversation',
  'chat.today': "Aujourd'hui",
  'chat.yesterday': 'Hier',
  'chat.thisWeek': 'Cette semaine',
  'chat.thisMonth': 'Ce mois-ci',
  'chat.older': 'Plus ancien',
  'chat.messages': 'messages',
  'chat.renameConversation': 'Renommer',
  'chat.deleteConversation': 'Supprimer',
  'chat.cancel': 'Annuler',
  'chat.rename': 'Renommer',
  'chat.delete': 'Supprimer',
  'chat.favorite': 'Ajouter aux favoris',
  'chat.unfavorite': 'Retirer des favoris',
  'chat.searchSessions': 'Rechercher des conversations...',
  'chat.noResults': 'Aucun résultat trouvé',
  'chat.noSessions': 'Pas encore de conversations',
  'chat.enterNewName': 'Entrez un nouveau nom...',
  'chat.deleteConfirmMessage':
    'Êtes-vous sûr de vouloir supprimer cette conversation ? Cette action ne peut pas être annulée.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Tapez votre question… (coûte 30 crédits)',
  'chat.send': 'Envoyer',
  'chat.voice': 'Parler',
  'chat.listeningPlaceholder': "J'écoute... Parlez maintenant.",
  'chat.stopListening': "Arrêter l'enregistrement",
  'chat.recording': 'Enregistrement...',
  'chat.speechNotSupported':
    'La reconnaissance vocale n\'est pas prise en charge par votre navigateur.',
  'chat.microphonePermissionDenied':
    "L'accès au microphone a été refusé. Veuillez autoriser l'accès dans les paramètres de votre navigateur.",
  'chat.errorNotEnoughCredits':
    'Pas assez de crédits. Veuillez mettre à jour votre plan ou attendre la prochaine réinitialisation.',
  'chat.errorAiFailed':
    'La réponse IA a échoué. Aucun crédit n\'a été déduit.',
  'chat.errorRateLimit': 'Trop de demandes. Veuillez patienter un instant.',

  // Ratings
  'rating.good': 'Bon',
  'rating.medium': 'Moyen',
  'rating.bad': 'Mauvais',

  // Auth Page
  'auth.branding.headline1': 'Toutes les idées ne sont pas bonnes.',
  'auth.branding.headline2': 'Nous vous le disons honnêtement.',
  'auth.branding.subtitle':
    'Une IA de décision pour les niches commerciales. Claire. Critique. Sans détour.',
  'auth.benefits.privacy.title': '100% Privé',
  'auth.benefits.privacy.desc':
    'Vos idées restent complètement privées et sécurisées.',
  'auth.benefits.honest.title': 'IA Honnête',
  'auth.benefits.honest.desc':
    'Sans détour – juste un feedback clair et critique.',
  'auth.benefits.fast.title': 'Résultats Rapides',
  'auth.benefits.fast.desc':
    'Obtenez de la clarté sur votre niche en quelques minutes.',
  'auth.trust.users': 'Utilisateurs Actifs',
  'auth.trust.ideas': 'Idées Analysées',
  'auth.trust.rating': 'Évaluation',
  'auth.login.title': 'Connexion',
  'auth.login.headline': 'Bon retour',
  'auth.login.subtitle': 'Connectez-vous pour continuer votre parcours.',
  'auth.login.forgotPassword': 'Mot de passe oublié ?',
  'auth.login.submit': 'Se Connecter',
  'auth.login.noAccount': 'Pas encore de compte ?',
  'auth.login.signUp': "S'inscrire",
  'auth.register.title': "S'inscrire",
  'auth.register.headline': 'Créez votre compte',
  'auth.register.subtitle':
    "Commencez à analyser vos idées commerciales aujourd'hui.",
  'auth.register.submit': 'Créer un Compte',
  'auth.register.hasAccount': 'Vous avez déjà un compte ?',
  'auth.register.signIn': 'Se connecter',
  'auth.fields.name': 'Nom Complet',
  'auth.fields.email': 'Adresse E-mail',
  'auth.fields.password': 'Mot de Passe',
  'auth.fields.confirmPassword': 'Confirmer le Mot de Passe',
  'auth.fields.selectPlan': 'Sélectionnez votre plan',
  'auth.placeholders.name': 'Entrez votre nom',
  'auth.placeholders.email': 'Entrez votre e-mail',
  'auth.placeholders.password': 'Entrez votre mot de passe',
  'auth.placeholders.confirmPassword': 'Confirmez votre mot de passe',
  'auth.terms.accept': "J'accepte les",
  'auth.terms.terms': 'Conditions Générales',
  'auth.privacy.accept': "J'accepte la",
  'auth.privacy.policy': 'Politique de Confidentialité',
  'auth.errors.nameRequired': 'Le nom est requis',
  'auth.errors.emailRequired': "L'e-mail est requis",
  'auth.errors.emailInvalid': 'Veuillez entrer un e-mail valide',
  'auth.errors.passwordRequired': 'Le mot de passe est requis',
  'auth.errors.passwordLength': 'Le mot de passe doit contenir au moins 8 caractères',
  'auth.errors.passwordMismatch': 'Les mots de passe ne correspondent pas',
  'auth.loading': 'Veuillez patienter...',
  'auth.or': 'ou continuer avec',
  'auth.social.google': 'Continuer avec Google',
  'auth.social.apple': 'Continuer avec Apple',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': 'Accès gratuit de 3 jours',
  'pricing.trial.credits': '250 crédits',
  'pricing.trial.free': 'Gratuit',
  'pricing.trial.duration': 'Sans frais pendant 3 jours',
  'pricing.trial.cta': 'Commencer l\'essai gratuit',
  'pricing.trial.feature1': '250 crédits pour explorer l\'IA',
  'pricing.trial.feature2': 'Accès complet pendant 3 jours',
  'pricing.trial.feature3': 'Aucune carte de crédit requise',
  'pricing.trial.feature4': 'Annulation à tout moment',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10 000 crédits + rapport Builder de 25 pages',
  'pricing.gold.credits': '10 000 crédits',
  'pricing.gold.feature1': '10 000 crédits',
  'pricing.gold.feature2': 'Rapport Builder de 25 pages',
  'pricing.gold.feature3': 'Toutes les fonctionnalités Starter et Pro',
  'pricing.gold.feature4': 'Analyse de marché et synthèse',
  'pricing.gold.feature5': 'Opportunités, risques, recommandations',
  'pricing.gold.feature6': 'Télécharger le PDF',
  'pricing.gold.feature7': 'Support',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15 000 crédits + rapport Builder de 75 pages',
  'pricing.platinum.credits': '15 000 crédits',
  'pricing.platinum.feature1': '15 000 crédits',
  'pricing.platinum.feature2': 'Rapport Builder de 75 pages',
  'pricing.platinum.feature3': 'Toutes les fonctionnalités Gold',
  'pricing.platinum.feature4': 'Mode Builder : briefings développeurs',
  'pricing.platinum.feature5': 'Résumé structuré',
  'pricing.platinum.feature6': 'Analyse de marché avancée',
  'pricing.platinum.feature7': 'Support',

  // Pricing UI
  'pricing.monthly': 'Mensuel',
  'pricing.yearly': 'Annuel',
  'pricing.savings': 'd\'économies',
  'pricing.billedYearly': 'Facturation annuelle',

  // Hero trial CTA
  'hero.trialTitle': 'Démarrez votre essai gratuit',
  'hero.creditsLabel': 'Crédits',
  'hero.trialTagline': 'Essayez notre assistant IA gratuitement pendant 3 jours',
  'hero.trialCta': 'Inscrivez-vous et obtenez 250 crédits',
  'hero.trialNoCard': 'Aucune carte de crédit requise. Sans engagement.',

  // Admin
  'admin.dashboard.tabs.plans': 'Plans',

  // Credit top-up
  'dashboard.credits.topup.button': 'Recharger des crédits',
  'dashboard.credits.topup.buttonTitle': 'Achetez plus de crédits sans changer de plan',
  'dashboard.credits.topup.title': 'Recharger des crédits',
  'dashboard.credits.topup.subtitle': 'CHF 0,15 par crédit — aucun changement de plan requis',
  'dashboard.credits.topup.quickAmounts': 'Sélection rapide',
  'dashboard.credits.topup.custom': 'Personnalisé',
  'dashboard.credits.topup.totalLabel': 'Total',
  'dashboard.credits.topup.creditsLabel': 'Crédits',
  'dashboard.credits.topup.confirm': 'Acheter maintenant',
  'footer.disclaimer': 'Avertissement',
  'legal.backToHome': 'Retour à l\'accueil',
  'legal.lastUpdated': 'Dernière mise à jour',
  'legal.allRightsReserved': 'Tous droits réservés.',
  'legal.authoritativeNotice': 'Une version localisée n\'est pas encore disponible dans votre langue. Le texte anglais qui fait foi est affiché ci-dessous.',
  'legal.translationNotice': 'Il s’agit d’une traduction de courtoisie. La version anglaise est l’original juridiquement contraignant.',
};

export default common;
